// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__GlNSG","content":"styles_content__1xoL4","checkbox":"styles_checkbox__1tGeT","checkboxLabel":"styles_checkboxLabel__3OEXS"};